import { connect } from 'react-redux';
import ChangeLanguage from './change_language';

const mapStateToProps = ({
  advisors,
  application
}) => ({
  advisors,
  dynamicConfig: application?.dynamicConfig
});

export default connect(
  mapStateToProps
)(ChangeLanguage);
